import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import Home from "@/pages/Home";
import CaseStudy from "@/pages/CaseStudy";
import AuthCallback from "@/pages/AuthCallback";
import Admin from "@/pages/Admin";
import Protected from "@/components/Protected";

// Reset scroll position on every route change.
function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Reads the OAuth session_id from the URL hash synchronously during render,
// BEFORE protected routes run — prevents the race where the auth check fires first.
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Protected><Home /></Protected>} />
      <Route path="/work/:slug" element={<Protected><CaseStudy /></Protected>} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

export default function App() {
  // Smooth momentum scrolling (Lenis), shared across pages via window.__lenis.
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollManager />
      <AppRouter />
    </BrowserRouter>
  );
}
